import React from "react";
import { SignOut } from "@phosphor-icons/react";

// Persistent, audited "acting as customer" bar. Shows whenever a staff member has
// entered a customer's dashboard to set them up. Exiting restores the staff session.
export function ImpersonationBanner() {
  let imp = null;
  try { imp = JSON.parse(localStorage.getItem("nexus_impersonation") || "null"); } catch { imp = null; }
  if (!imp) return null;

  const exit = () => {
    const staff = localStorage.getItem("nexus_staff_token");
    if (staff) localStorage.setItem("nexus_token", staff);
    else localStorage.removeItem("nexus_token");
    localStorage.removeItem("nexus_staff_token");
    localStorage.removeItem("nexus_impersonation");
    window.location.href = "/command/users";
  };

  return (
    <div data-testid="impersonation-banner"
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-center text-sm font-semibold text-black">
      <span>Setting up <b>{imp.name}</b> — changes affect this customer’s account.</span>
      <button data-testid="impersonation-exit" onClick={exit}
        className="inline-flex items-center gap-1 rounded-full bg-black/85 px-3 py-1 text-xs font-bold text-white transition-colors hover:bg-black">
        <SignOut size={14} weight="bold" /> Exit setup
      </button>
    </div>
  );
}

export default ImpersonationBanner;
